module.exports = __webpack_public_path__ + "files/1eb68ed592e3d9630dfc68c2cdb00426.png";